module.exports = __webpack_public_path__ + "static/Pool_Cabanas_04A_copy-05c3bef5b1529a1b75a47ac21df3ee3e.jpg";